import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FeedbackTrackingService {
    private readonly submittedFeedbackIds$ = new BehaviorSubject<Set<string>>(new Set());

    get submittedFeedbackIds(): Observable<Set<string>> {
        return this.submittedFeedbackIds$.asObservable();
    }

    markFeedbackSubmitted(requestId: string): void {
        const currentSet = this.submittedFeedbackIds$.value;
        const newSet = new Set(currentSet);
        newSet.add(requestId);
        this.submittedFeedbackIds$.next(newSet);
        // console.log('🎯 Marked feedback as submitted for requestId:', requestId, 'Total submitted:', newSet.size);
    }

    isFeedbackSubmitted(requestId: string): boolean {
        return this.submittedFeedbackIds$.value.has(requestId);
    }

    clearSubmittedFeedback(): void {
        this.submittedFeedbackIds$.next(new Set());
        // console.log('🧹 Cleared all submitted feedback tracking');
    }
}
